/*
 * @Description: 列表、详情首次出现的字段与复用混合字段 fields静态字段 createField创建字段方法。大列表多态形式必须统一注册渲染字段！
 * @Date: 2020-01-04 11:15:59
 */
import {
  digitImage,
  renderShowImage,
  authFilter,
  rarestyle,
  completeRare,
  handlePics,
  handleClickItem
} from './tool';
import { getTypeToString } from '@/tools/index';
import dateFormat from '@/tools/dateFormat';
import { moneyFixed, handleMoney } from '@/components/tableRender/util';
import dayjs from 'dayjs';
import checkImage from '../components/checkImage.vue';

const fields = {
  index: {
    type: 'index'
  },
  operateProjectNo: {
    label: '运营编码',
    prop: 'operateProjectNo',
    render(h, ctx, row, column) {
      return <span>{row['operateProjectNo'] || '-'}</span>;
    }
  },
  expand_19: {
    label: '详情',
    type: 'expand',
    expandFields: []
  },
  industryEnterpriseName: {
    label: '工业方', // 显示label
    prop: 'industryEnterpriseName' // 对应字段
  },
  enterpriseName: {
    label: '服务商', // 显示label
    prop: 'enterpriseName' // 对应字段
  },
  enterprise_name: {
    label: '服务商', // 显示label
    prop: 'enterprise_name' // 对应字段
  },
  supplierEnterpriseName: {
    label: '供应商', // 显示label
    prop: 'supplierEnterpriseName' // 对应字段
  },
  zooidEnterpriseName: {
    label: '个体',
    prop: 'zooidEnterpriseName',
    formatter: function(row) {
      return row.zooidEnterpriseName || row.userEnterpriseName || '-';
    }
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  project_name: {
    label: '项目名称',
    prop: 'project_name'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  task_dt: {
    label: '任务月度',
    prop: 'task_dt'
  },
  agentName: {
    label: '项目参与人',
    prop: 'agentName'
  },
  fullName: {
    label: '项目参与人',
    prop: 'fullName'
  },
  FullName: {
    label: '项目参与人',
    prop: 'FullName'
  },
  full_name: {
    label: '项目参与人',
    prop: 'full_name'
  },
  fullName_check: {
    label: '项目参与人',
    prop: 'fullName',
    render(h, ctx, row, column, columnIndex) {
      const name =
        row.fullName || row.agentName || row.full_name || row.FullName;
      return (
        <div style="display: flex;align-items: center;justify-content: center;">
          {row.isPicRepeat == 1 && (
            <img
              class="el-icon-warning"
              style="width: 20px;height:20px;cursor:pointer;margin-right:5px"
              src={require(`@/assets/重复报警.png`)}
              onClick={() => {
                ctx.parent.$xrkDialog({
                  title: '图片重复关联项目',
                  hideFooter: true,
                  $slots: {
                    default: ctx.parent.$createElement(checkImage, {
                      props: {
                        row,
                        projectType: ctx.parent.target.projectType
                      }
                    })
                  }
                });
              }}
            />
          )}
          <span>{name}</span>
        </div>
      );
    }
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  customerName: {
    label: '客户姓名',
    prop: 'customerName'
  },
  hospitalName: {
    label: '医院',
    prop: 'hospitalName'
  },
  hospitalAddress: {
    label: '医院地址',
    prop: 'hospitalAddress'
  },
  firstHospitalMonth: {
    label: '首次进院月份',
    prop: 'firstHospitalMonth'
  },
  visitTime: {
    label: '拜访时间',
    prop: 'visitTime'
  },
  visitMinute: {
    label: '拜访时长(分)',
    prop: 'visitMinute'
  },

  visitAddress: {
    label: '拜访地点',
    prop: 'visitAddress'
  },
  // authStatus: {
  //   label: '状态',
  //   prop: 'authStatus',
  //   formatter:i => {
  //     i.revoke === 2?'':authFilter(i.authStatus)
  //   }  // 自定义内容方法
  // },
  // auditStatus: {
  //   label: '状态',
  //   prop: 'auditStatus',
  //   formatter:i => {
  //     i.revoke === 2?'':authFilter(i.auditStatus)
  //   }  // 自定义内容方法
  // },
  // audit_status: {
  //   label: '状态',
  //   prop: 'audit_status',
  //   formatter:i => {
  //     i.revoke === 2?'':authFilter(i.audit_status)
  //   }  // 自定义内容方法
  // },
  authStatus: {
    label: '审核状态',
    prop: 'authStatus',
    formatter: authFilter('authStatus') // 自定义内容方法
  },
  auditStatus: {
    label: '审核状态',
    prop: 'auditStatus',
    formatter: authFilter('auditStatus') // 自定义内容方法
  },
  audit_status: {
    label: '状态',
    prop: 'audit_status',
    formatter: authFilter('audit_status')
  },
  departmentName: {
    label: '科室',
    prop: 'departmentName'
  },
  dutyName: {
    label: '职称',
    prop: 'dutyName'
  },
  hospital: {
    label: '医院',
    prop: 'hospital'
  },
  taskSum: {
    label: '计划任务量',
    prop: 'taskSum',
    formatter: i => {
      if (i.taskSum === null || i.taskSum === undefined) {
        return '-';
      }
      return i.taskSum;
    }
  },
  task_sum: {
    label: '计划任务量',
    prop: 'task_sum',
    formatter: i => {
      if (i.task_sum === null || i.task_sum === undefined) {
        return '-';
      }
      return i.task_sum;
    }
  },
  finishSum: {
    label: '实际完成量',
    prop: 'finishSum'
  },
  finish_sum: {
    label: '实际完成量',
    prop: 'finish_sum'
  },
  notFinish: {
    label: '未完成量',
    prop: 'notFinish',
    formatter: i => {
      if (i.notFinish === null || i.notFinish === undefined) {
        return '-';
      }
      return i.notFinish;
    }
  },
  uncompletedQuantity: {
    label: '未完成量',
    prop: 'uncompletedQuantity',
    formatter: i => {
      if (
        i.uncompletedQuantity === null ||
        i.uncompletedQuantity === undefined
      ) {
        return '-';
      }
      return i.uncompletedQuantity;
    }
  },
  nofinish: {
    label: '未完成量',
    prop: 'nofinish',
    formatter: i => {
      if (i.nofinish === null || i.nofinish === undefined) {
        return '-';
      }
      return i.nofinish;
    }
  },
  passSum: {
    label: '审核通过量',
    prop: 'passSum'
  },
  pass: {
    label: '审核通过量',
    prop: 'pass'
  },
  passing: {
    label: '审核中',
    prop: 'passing',
    formatter: row => {
      // 后端兄弟给点力，统一一下字段名哇。
      if (row.passing || row.passing === 0) {
        return row.passing;
      } else if (row.passingSum || row.passingSum === 0) {
        return row.passingSum;
      } else {
        return '-';
      }
    }
  },
  notPassSum: {
    label: '审核未通过量',
    prop: 'notPassSum'
  },
  passSum_19_1: {
    use: [1],
    label: '审核通过量',
    prop: 'passSum',
    formatter: function() {
      return '-';
    }
  },
  passSum_19_2: {
    use: [2],
    label: '审核通过量',
    prop: 'passSum'
  },
  notPassSum_19_1: {
    use: [1],
    label: '审核未通过量',
    prop: 'notPassSum',
    formatter: function() {
      return '-';
    }
  },
  notPassSum_19_2: {
    use: [2],
    label: '审核未通过量',
    prop: 'notPassSum'
  },
  title: {
    label: '病例标题',
    prop: 'title'
  },
  bingliImg: {
    label: '照片',
    img: true,
    str2Arr: true,
    prop: 'bingliImg'
  },
  bingliFile: {
    label: '附件',
    file: true,
    prop: 'bingliFile'
  },
  content: {
    label: '描述',
    prop: 'content'
  },
  nopass: {
    label: '审核未通过量',
    prop: 'nopass'
  },
  finishRate: {
    label: '任务完成率',
    prop: 'finishRate',
    formatter: completeRare('finishRate'),
    style: rarestyle('finishRate')
  },
  completionRate: {
    label: '完成率',
    prop: 'completionRate',
    style: rarestyle('completionRate'),
    formatter: completeRare('completionRate')
  },
  gradeName: {
    label: '医院等级',
    prop: 'gradeName'
  },
  digitGradeName: {
    use: [1],
    label: '医院等级',
    prop: 'gradeName'
  },
  messages: {
    label: '传递信息',
    prop: 'messages'
  },
  customerRemark: {
    label: '客户反馈',
    prop: 'customerRemark'
  },
  product_name: {
    label: '产品名称',
    prop: 'product_name'
  },
  productName: {
    label: '产品名称',
    prop: 'productName'
  },
  jixing: {
    label: '产品剂型',
    prop: 'jixing'
  },
  guige: {
    label: '产品规格',
    prop: 'guige'
  },
  approval_number: {
    label: '产品国药准字',
    prop: 'approval_number'
  },
  pharmacyName: {
    label: '药店名称',
    prop: 'pharmacyName'
  },
  startDt: {
    label: '巡店时间',
    prop: 'startDt'
  },
  startdt: {
    label: '会议时间',
    prop: 'startdt'
  },
  price: {
    label: '全国指导价',
    prop: 'price'
  },
  productRequire: {
    label: '陈列要求',
    prop: 'productRequire'
  },
  createDt: {
    label: '提交时间',
    prop: 'createDt'
  },
  meetingMinute: {
    label: '会议时长',
    prop: 'meetingMinute'
  },
  longitudeAndLatitude: {
    label: '定位',
    prop: 'longitudeAndLatitude'
  },
  signCount: {
    label: '签到人数',
    prop: 'signCount'
  },
  customerFeedback: {
    label: '人员反馈',
    prop: 'customerFeedback'
  },
  finishDT: {
    label: '任务月度',
    prop: 'finishDT'
  },
  finishDt_20: {
    label: '提交时间',
    prop: 'finishDt',
    formatter: i => {
      const time = i['finishDt'];
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '-';
    }
  },
  startdtChn: {
    label: '拜访时间',
    prop: 'startdtChn'
  },
  stock: {
    label: '库存',
    prop: 'stock'
  },
  assistantAlliance: {
    label: '场景类型',
    prop: 'assistantAlliance'
  },
  medicalAlliance: {
    label: '场景类型',
    prop: 'medicalAlliance'
  },
  imgUrl: {
    label: '陈列照片',
    prop: 'imgUrl',
    img: true,
    str2Arr: true
  },
  imgUrl$detail: {
    label: '陈列照片',
    prop: 'imgUrl',
    img: true,
    str2Arr: true
  },
  salesPrice: {
    label: '售价',
    prop: 'salesPrice',
    formatter: i => {
      const pic = +i['salesPrice'] || 0;
      return pic.toFixed(2);
    }
  },
  displayStatus: {
    label: '陈列状态',
    prop: 'displayStatus',
    formatter: i => {
      const status = i['displayStatus'];
      return status == 1 ? '优秀' : status == 2 ? '合格' : '不合格';
    }
  },
  isProdectPop: {
    label: '是否有POP',
    prop: 'isProdectPop',
    formatter: i => {
      const status = +i['isProdectPop'];
      return status == 1 ? '是' : '否';
    }
  },
  isKnow: {
    label: '是否知道卖点',
    prop: 'isKnow',
    formatter: i => {
      const status = +i['isKnow'];
      return status == 1 ? '知道' : '不知道';
    }
  },
  imgUrl0: {
    label: '陈列照片',
    prop: 'imgUrl',
    render: handlePics(0, 'string')
  },
  imgUrl1: {
    label: '陈列照片',
    prop: 'imgUrl',
    render: handlePics(1, 'string')
  },
  imgUrl2: {
    label: '陈列照片',
    prop: 'imgUrl',
    render: handlePics(2, 'string')
  },
  competitor: {
    label: '主要竞品',
    prop: 'competitor'
  },
  imgUrl$0: {
    label: '陈列照片',
    img: true,
    prop: 'imgUrl',
    render: handlePics(0, 'string')
  },
  imgUrl$1: {
    label: '陈列照片',
    img: true,
    prop: 'imgUrl_1',
    render: handlePics(0, 'string')
  },
  imgUrl$2: {
    label: '陈列照片',
    img: true,
    prop: 'imgUrl_2',
    render: handlePics(0, 'string')
  },
  addressPicUrl: {
    label: '地点',
    img: true,
    prop: 'addressPicUrl',
    render: handlePics(0, 'string')
  },
  zppic1: {
    use: [0, 1, 2, 3],
    label: '陈列照片',
    prop: 'zppic1',
    render: handlePics(0)
  },
  zppic2: {
    use: [0, 1, 2, 3],
    label: '陈列照片',
    prop: 'zppic2',
    render: handlePics(0)
  },
  zppic3: {
    use: [0, 1, 2, 3],
    label: '陈列照片',
    prop: 'zppic3',
    render: handlePics(0)
  },
  urls: {
    label: '陈列照片',
    prop: 'urls',
    str2Arr: true,
    img: true
  },
  jhpic1: {
    label: '首次进货流向',
    prop: 'jhpic1',
    render: handlePics(0)
  },
  jhpic2: {
    label: '首次进货流向',
    prop: 'jhpic2',
    render: handlePics(0)
  },
  jhpic3: {
    label: '首次进货流向',
    prop: 'jhpic3',
    render: handlePics(0)
  },
  jypic1: {
    label: '医院进院批准',
    prop: 'jypic1',
    render: handlePics(0)
  },
  jypic2: {
    label: '医院进院批准',
    prop: 'jypic2',
    render: handlePics(0)
  },
  jypic3: {
    label: '医院进院批准',
    prop: 'jypic3',
    render: handlePics(0)
  },
  zlpic1: {
    label: '补充',
    prop: 'zlpic1',
    render: handlePics(0)
  },
  zlpic2: {
    label: '补充',
    prop: 'zlpic2',
    render: handlePics(0)
  },
  zlpic3: {
    label: '补充',
    prop: 'zlpic3',
    render: handlePics(0)
  },
  common_U0123_jhpic1: {
    use: [0, 1, 2, 3],
    label: '首次进货流向',
    prop: 'jhpic1',
    render: handlePics(0)
  },
  common_U0123_jhpic2: {
    use: [0, 1, 2, 3],
    label: '首次进货流向',
    prop: 'jhpic2',
    render: handlePics(0)
  },
  common_U0123_jhpic3: {
    use: [0, 1, 2, 3],
    label: '首次进货流向',
    prop: 'jhpic3',
    render: handlePics(0)
  },
  //
  common_U123_messages: {
    use: [1, 2, 3],
    label: '传递信息',
    //乙方字段为 transmitList
    prop: 'messages'
  },
  // 带有过滤器的通用字段
  commonFormatterVisitMinute: {
    label: '拜访时长(分)',
    prop: 'visitMinute',
    formatter1(row, column) {
      let value = row[column.property];
      return value;
      // return row || row === 0 ? row : '';le.log(value,2222)
    }
  },
  // 不显示label的
  commonEmpty_U_123_visitAddress: {
    use: [1, 2, 3],
    prop: 'visitAddress',
    label: ''
  },
  // 不显示label的
  commonEmpty_U_0123_visitAddress: {
    use: [0, 1, 2, 3],
    prop: 'visitAddress',
    label: ''
  },
  // 带有render的通用字段
  commonRender_U_0123_addressWatermarkPicUrl: {
    use: [0, 1, 2, 3], // 是否使用该字段，判断条件是否在其中，存在则显示， 该字段如果没有则默认使用该字段
    label: '拜访地点',
    prop: 'addressWatermarkPicUrl',
    // TODO: 需要以指令方式重构
    render: renderShowImage
  },
  // 带有图片的通用字段 -- 详情
  commonImg_U_0123_addressWatermarkPicUrl: {
    use: [0, 1, 2, 3], // 是否使用该字段，判断条件是否在其中，存在则显示， 该字段如果没有则默认使用该字段
    label: '拜访地点',
    prop: 'addressWatermarkPicUrl',
    img: true, // 显示图片
    str2Arr: false // 是否使用split分割图片，true标识需要分割并且img是以;形式接受
  },
  commonRender_U_1_autographPicUrl: {
    use: [1],
    label: '客户签名',
    prop: 'autographPicUrl',
    render: renderShowImage
  },
  commonImg_U_1_autographPicUrl: {
    use: [1],
    label: '客户签名',
    prop: 'autographPicUrl',
    img: true,
    str2Arr: false
  },
  commonRender_Q_0_U_23_pics: {
    use: [2, 3],
    label: '现场照片',
    prop: 'pics',
    render: handlePics(0)
  },
  commonRender_Q_1_U_23_pics: {
    use: [2, 3],
    label: '现场照片',
    prop: 'pics',
    render: handlePics(1)
  },
  signInfo: {
    label: '签到详情',
    type: 'table',
    prop: 'signInfo'
  },
  commonRender_Q_2_U_23_pics: {
    use: [2, 3],
    label: '现场照片',
    prop: 'pics',
    render: handlePics(2)
  },
  // 带有图片分割的通用  -- 详情
  commonImg_U_23_pics: {
    use: [2, 3],
    label: '现场照片',
    prop: 'pics',
    img: true,
    str2Arr: true
  },
  //todo 1医院名称 2医疗机构名称 3药店名称1  等级医院 2 基层医疗机构 3 药店
  //客户名称(customerName)、医院名称/医疗机构名称(hospitalName),药店名称(pharmacyName)
  yymc: {
    use: [1],
    prop: 'hospitalName',
    label: '医院名称'
  },
  yljgmc: {
    use: [2],
    prop: 'hospitalName',
    label: '医疗机构名称'
  },
  ydmc: {
    use: [3],
    prop: 'pharmacyName',
    label: '药店名称'
  },
  //todo 信息转发记录, 信息反馈记录,
  forward: {
    prop: 'pics',
    label: '信息转发记录',
    render: digitImage('forward')
  },
  feedback: {
    prop: 'pics',
    label: '信息反馈记录',
    render: digitImage('feedback')
  },
  feedbackContent: {
    prop: 'feedbackContent',
    label: '客户反馈'
  },
  //todo 协定服务
  zdje: {
    prop: 'finishSumTaskPrice',
    label: '终端结算金额',
    render: handleMoney
  },
  fileCount: {
    prop: 'uploadNum',
    label: '上传附件数'
  },
  FolderName: {
    prop: 'FolderName',
    label: '文件名称'
  },
  // {
  //   label: '失效任务量',
  //   prop: 'invalidCount',
  //   formatter: () => {
  //     return '-';
  //   }
  // }
  invalidCount: {
    prop: 'invalidTaskSum',
    label: '失效任务量',
    formatter: i => {
      if (!i.invalidTaskSum) {
        return 0;
      }
      return i.invalidTaskSum;
    }
  },
  finishStatus: {
    use: [1],
    prop: 'audit_status',
    label: '结算状态',
    formatter(row, column) {
      let status = +row['audit_status'];
      return status === 2 ? '可结算' : '不可结算';
    }
  },

  auditStatus_19: {
    label: '状态',
    use: [2],
    prop: 'audit_status',
    formatter: authFilter('audit_status')
  },
  auditStatus_20: {
    label: '状态',
    use: [2],
    prop: 'audit_status',
    formatter: authFilter('auditStatus')
  },
  taskCode: {
    prop: 'taskCode',
    label: '任务编码',
    formatter(row, column) {
      return row['taskCode'] || '-';
    }
  },
  signingStatus: {
    prop: 'signing_status',
    label: '签约状态',
    formatter(row, column) {
      let status = row['signing_status'];
      if (!status) {
        return '-';
      }
      let obj = {
        //        签约状态 0 未签署  1 签约中  2 签约成功 3 签约失败"
        0: '未签署',
        1: '签约中',
        2: '签约成功',
        3: '签约失败'
      };

      return obj[status] || '-';
    }
  },
  // 可配场景动态渲染
  sceneCustom: {
    customColumn: true,
    render(h, ctx, row, column, columnIndex) {
      let table = ctx.parent;
      let { tableData } = table;
      let {
        isSetTarget,
        targetTitle,
        isSetTime,
        timeTitle,
        isSetLocation,
        locationTitle,
        formatAnswer
      } = tableData[0] || [];
      let targeDom = () => {
        let localScopedSlot = {
          default: ({ $index, column, row }) => {
            return (
              <el-image
                src={row.addressPicUrl}
                preview-src-list={[row.addressPicUrl]}
                onClick={handleClickItem.bind(null, ctx.parent)}
              />
            );
          }
        };
        let timeScopedSlot = {
          default: ({ $index, column, row }) => {
            return <span>{row.timeQuestions}</span>;
          }
        };
        let targetScopeSlot = {
          default: ({ $index, column, row }) => {
            return (
              <el-tooltip
                effect="dark"
                content={row.customerName}
                placement="top"
                popper-class="custom-tooltip"
              >
                <span>
                  {`${row.customerName}`.replace(
                    /(.{100})(.*)/,
                    (str, rA, rB) => {
                      return rB ? rA + '...' : rA;
                    }
                  )}
                </span>
              </el-tooltip>
            );
          }
        };
        if (isSetTarget) {
          return (
            <template>
              {isSetTarget && (
                <el-table-column
                  align="center"
                  prop="customerName"
                  width="200px"
                  label={targetTitle}
                  {...{ scopedSlots: targetScopeSlot }}
                />
              )}
              {isSetTime && (
                <el-table-column
                  align="center"
                  prop="customerName"
                  width="200px"
                  label={timeTitle}
                  {...{ scopedSlots: timeScopedSlot }}
                />
              )}
              {isSetLocation && (
                <el-table-column
                  align="center"
                  prop="customerName"
                  width="200px"
                  label={locationTitle}
                  {...{ scopedSlots: localScopedSlot }}
                />
              )}
            </template>
          );
        }
      };
      let imgDom = () => {
        const scopedSlots = {
          default: ({ $index, column }) => {
            return (
              <div style="display:flex">
                {(
                  tableData[$index].formatAnswer[column.index].answer || []
                ).map(file => {
                  return (
                    <el-image
                      style="margin-right: 10px;"
                      src={file.url}
                      preview-src-list={[file.url]}
                      onClick={handleClickItem.bind(null, ctx.parent)}
                    />
                  );
                })}
              </div>
            );
          }
        };
        if (formatAnswer && formatAnswer.length) {
          return formatAnswer.map((item, index) => {
            return (
              <el-table-column
                align="center"
                prop="customerName"
                width="400px"
                index={index}
                label={item.title}
                {...{ scopedSlots }}
              ></el-table-column>
            );
          });
        }
      };
      return (
        <template>
          {targeDom()}
          {imgDom()}
        </template>
      );
    }
  }
};

/**
 * @description: 创建对应需要字段，混合数据
 * @param {string|object} fieldList 对应字段，string:字段名称 object:带有混合数据
 * @return: []
 */
const createField = fieldList => {
  if (getTypeToString(fieldList) === '[object Array]') {
    return fieldList.map(item => {
      if (item) {
        if (getTypeToString(item) === '[object String]' && fields[item]) {
          return fields[item];
        } else if (
          getTypeToString(item) === '[object Object]' &&
          item.prop &&
          fields[item.prop]
        ) {
          return { ...fields[item.prop], ...item };
        } else {
          throw new Error(
            'createField中item类型错误 string | object, 且对应字段必须在fields中存在'
          );
        }
      }
    });
  } else {
    throw new Error('create中必须传入数组');
  }
};
export default createField;
